export default "__VITE_ASSET__YcA0vNyX__"